"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  add: 'Add',
  backorders: 'Backorders',
  bpCount: '{0} BP',
  chooseTheCustomerOrders: 'Choose the customer orders that you want to add to your current order',
  customerOrders: 'Customer orders',
  dontMissOut: "Don't miss out",
  editCustomerOrders: 'Edit customer orders',
  forEstimatedDates: 'For estimated dates, please see their product page',
  pleaseNote: 'Please note:',
  rememberToAlwaysContactYourCustomersPersonallyBeforeYouApproveAnyOrders: 'remember to always contact your customers personally before you approve any orders',
  reservedProducts: 'Reserved products',
  selectedOrdersCount: '{0} of {1} orders selected',
  theProductsYouHaveReserved: 'The products you have reserved for when they are back in stock',
  total: 'Total'
};
const translationsNamespace = exports.translationsNamespace = 'checkout-merchandising';